import React, { useEffect, useState } from "react";
import { LoadPanel ,Button } from "devextreme-react";
import { useNavigate, useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  getContactById,
  updateCustomerContact,
} from "../../../api/companyCustomerApi";

import CancelSaveHeader from "../../../components/customPageHeader/CancelSaveHeader";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import CustomTextBox from "../../../components/customTextBox/CustomTextBox";
import CustomDropdown from "../../../components/customDropDown/CustomDropdown";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import { custStatusDataSource2 } from "../../customers/data";
import { getDepartments } from "../../../api/departmentApi";

export default function EditContact() {
  const navigate = useNavigate();

  const location = useLocation();
  const { contacttransid } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    contactname: "",
    contactcode: "",
    contactemail: "",
    contactnumber: "",
    department: "",
    status: "",
  });

  const [departmentList, setDepartmentList] = useState([]);
  const departmentDataSource = departmentList.map((dept) => ({
    text: dept.departmentname,
    value: dept.transid,
  }));
  
  // ================= FETCH CONTACT =================
 useEffect(() => {
  const loadData = async () => {
    try {
      setLoading(true);

      const deptRes = await getDepartments();
      if (deptRes.success) {
        setDepartmentList(deptRes.data.data || []);
      }

      if (contacttransid) {
        const contactRes = await getContactById(contacttransid);

        setFormData({
          contactname: contactRes.data.contactname || "",
          contactcode: contactRes.data.contactcode || "",
          contactemail: contactRes.data.contactemail || "",
          contactnumber: contactRes.data.contactnumber || "",
          status: contactRes.data.status || "",
          department: contactRes.data.department || "",
        });
      }
    } catch (error) {
      ToastDisplayer("error", "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  loadData();
}, [contacttransid]);
  // ================= VALIDATION =================
  const validateForm = () => {
    const newErrors = {};

    if (!formData.contactname.trim())
      newErrors.contactname = "Contact name is required.";

    if (!formData.contactemail.trim())
      newErrors.contactemail = "Email is required.";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.contactemail))
      newErrors.contactemail = "Invalid email format.";

    if (!formData.contactnumber.trim())
      newErrors.contactnumber = "Phone number is required.";

    if (!formData.status) newErrors.status = "Status is required.";
    if (!formData.department) newErrors.status = "department is required.";


    setErrors(newErrors);

    Object.values(newErrors).forEach((err) => ToastDisplayer("error", err));

    return Object.keys(newErrors).length === 0;
  };

  // ================= INPUT CHANGE =================
  const handleInputChange = (field) => (e) => {
    const value = e?.value || "";

    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [field]: undefined,
    }));
  };

  // ================= SAVE =================
  const handleSave = async () => {
    if (!validateForm()) return;

    try {
      setLoading(true);

      await updateCustomerContact(contacttransid, formData);

      ToastDisplayer("success", "Contact updated successfully!");
      navigate("/contact");
    } catch (error) {
      ToastDisplayer("error", error.response?.data?.message || "Update failed");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/contact");
  };

  // ================= UI =================
  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="addCustPage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-edit-line"></i>
              </span>
              {/* <p>Edit Contact</p> */}
               <BreadCrumb/>
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Cancel"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleCancel}
            />

            <Button
            className="saveBtn"
              text="Save Details"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleSave}
            />
          </div>
        </div>
        
        <div className="customerMain">
          <div className="mainAddCustSection">
            <CustomTextBox
              label="Contact Code"
              value={formData.contactcode}
              readOnly
            />

            <CustomTextBox
              label="Contact Name"
              value={formData.contactname}
              onChange={handleInputChange("contactname")}
            />

            <CustomTextBox
              label="Email"
              value={formData.contactemail}
              onChange={handleInputChange("contactemail")}
              readOnly
            />

            <CustomTextBox
              label="Phone Number"
              value={formData.contactnumber}
              onChange={handleInputChange("contactnumber")}
            />

            <CustomDropdown
              label="Status"
              myDataSource={[
                { text: "Active", value: "Active" },
                { text: "Inactive", value: "Inactive" },
              ]}
              value={formData.status || null}
              setSelectedValue={(selectedItem) =>
                setFormData((prev) => ({
                  ...prev,
                  status: selectedItem?.value,
                }))
              }
            />
            <CustomDropdown
              label="Department"
              myDataSource={departmentDataSource}
              // placeholder="Select Department"
              value={departmentDataSource.length ? formData.department : null}
              setSelectedValue={(selectedItem) =>
                setFormData((prev) => ({
                  ...prev,
                  department: selectedItem?.value,
                }))
              }
            />
          </div>
        </div>
      </div>
    </>
  );
}
